module.exports = __webpack_public_path__ + "img/lt.3a8ae5d7.jpg";